/**
 * @returns {Object | null}
 */
export default function (payments) {
  const bonusesPayments = payments.filter(p => p.method.id === 'bonuses');
  // TODO handle `> 1` case.
  if (bonusesPayments.length > 1) {
    console.warn('Found more than one bonuses transaction. Returning only the first one\'s amount');
    return bonusesPayments[0].amount;
  }
  return bonusesPayments[0]?.amount || null;
}
